export default __webpack_public_path__ + "static/media/Gráfica_2_AppertFlow_Web.2b1f0757.webp";